import React from "react"
import {FieldArray, withFormik} from 'formik';
import {FormattedMessage, injectIntl} from "react-intl";
import {displayErrors, parsePropertiesErrors} from "../../../form-helpers";
import {handleApiResponse, types as actions} from "../../../crud-actions";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {Link} from "react-router-dom";
import SuccessModal from "../success-modal";
import AttachmentsList from "../attachments-list";
import ContentUnitHeader from "../content-unit-header";
import BaseComponent from "../../base-component";

class PersonalFormSubmitModal extends BaseComponent {
    render() {
        const { isOpen, isSubmitting, toggle, submit } = this.props;

        return (
            <Modal isOpen={isOpen || isSubmitting} toggle={toggle} className={this.props.className} size='lg'>
                <ModalHeader toggle={toggle}><FormattedMessage id='app.personal_forms.submit_modal.title'/></ModalHeader>
                <ModalBody>
                    <p><FormattedMessage id='app.personal_forms.submit_modal.confirmation'/></p>
                    <p><FormattedMessage id='app.personal_forms.changes'/></p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => { submit(); toggle(); }} disabled={isSubmitting}><FormattedMessage id='app.personal_forms.submit_modal.submit'/>{this.spinner(isSubmitting)}</Button>
                    <Button color="secondary" onClick={toggle}><FormattedMessage id='app.personal_forms.submit_modal.close'/></Button>
                </ModalFooter>
            </Modal>
        )
    };
}

class InnerForm extends BaseComponent {

    constructor(params) {
        super(params);
        this.state = {
            submitModal: false
        };
    }

    toggle = () => {
        this.setState({ submitModal: !this.state.submitModal });
        document.activeElement.blur();
    };

    render() {
        const { intl, values, touched, errors, handleChange, handleBlur, handleSubmit, submitForm, isSubmitting, setFieldValue, isComplete } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <p><FormattedMessage id='app.personal_forms.message.required_fields'/> (<span className='text-red'>*</span>)</p>
                <hr/>
                { displayErrors(errors, 'base') }
                <div className='row'>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.surname'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.surname' value={values.data.surname} onChange={handleChange}/>
                            { displayErrors(errors, 'data.surname') }
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.name'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.name' value={values.data.name} onChange={handleChange}/>
                            { displayErrors(errors, 'data.name') }
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.title'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.title' value={values.data.title} onChange={handleChange}/>
                            { displayErrors(errors, 'data.title') }
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.former_surname'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.former_surname' value={values.data.former_surname} onChange={handleChange}/>
                            { displayErrors(errors, 'data.former_surname') }
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.second_surname'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.second_surname' value={values.data.second_surname} onChange={handleChange}/>
                            { displayErrors(errors, 'data.second_surname') }
                        </div>
                    </div>
                </div>

                <br/>

                <div className='row'>
                    <div className='col-md-6'>
                        <p><FormattedMessage id='app.personal_forms_old.attribute.address'>{(txt) => (<label>{txt}</label>)}</FormattedMessage></p>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.address_street'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.address_street' value={values.data.address_street} onChange={handleChange}/>
                            { displayErrors(errors, 'data.address_street') }
                        </div>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.address_city'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.address_city' value={values.data.address_city} onChange={handleChange}/>
                            { displayErrors(errors, 'data.address_city') }
                        </div>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.address_postcode'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.address_postcode' value={values.data.address_postcode} onChange={handleChange}/>
                            { displayErrors(errors, 'data.address_postcode') }
                        </div>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.address_country'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.address_country' value={values.data.address_country} onChange={handleChange}/>
                            { displayErrors(errors, 'data.address_country') }
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <p><FormattedMessage id='app.personal_forms_old.attribute.contact_address'>{(txt) => (<label>{txt}</label>)}</FormattedMessage></p>

                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.contact_address_street'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.contact_address_street' value={values.data.contact_address_street} onChange={handleChange}/>
                            { displayErrors(errors, 'data.contact_address_street') }
                        </div>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.contact_address_city'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.contact_address_city' value={values.data.contact_address_city} onChange={handleChange}/>
                            { displayErrors(errors, 'data.contact_address_city') }
                        </div>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.contact_address_postcode'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.contact_address_postcode' value={values.data.contact_address_postcode} onChange={handleChange}/>
                            { displayErrors(errors, 'data.contact_address_postcode') }
                        </div>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.contact_address_country'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.contact_address_country' value={values.data.contact_address_country} onChange={handleChange}/>
                            { displayErrors(errors, 'data.contact_address_country') }
                        </div>
                    </div>
                </div>

                <br/>

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.phone'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.phone' value={values.data.phone} onChange={handleChange}/>
                            { displayErrors(errors, 'data.phone') }
                        </div>
                    </div>
                </div>

                <br/>

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.date_of_birth'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.date_of_birth' value={values.data.date_of_birth} onChange={handleChange}/>
                            { displayErrors(errors, 'data.date_of_birth') }
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.place_of_birth'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.place_of_birth' value={values.data.place_of_birth} onChange={handleChange}/>
                            { displayErrors(errors, 'data.place_of_birth') }
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.citizenship'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.citizenship' value={values.data.citizenship} onChange={handleChange}/>
                            { displayErrors(errors, 'data.citizenship') }
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.personal_identification_number'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.personal_identification_number' value={values.data.personal_identification_number} onChange={handleChange}/>
                            { displayErrors(errors, 'data.personal_identification_number') }
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.student'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage><br/>
                            <label onClick={() => { setFieldValue('data.student', '1') }}>
                                <input disabled={isComplete} id='data.student' name='data.student' type="radio" value={values.data.student} checked={values.data.student === '1'} onChange={() => { setFieldValue('data.student', '1') }} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.student.true'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            <label onClick={() => { setFieldValue('data.student', '0') }}>
                                <input disabled={isComplete} id='data.student' name='data.student' type="radio" value={values.data.student} checked={values.data.student === '0'} onChange={() => { setFieldValue('data.student', '0') }} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.student.false'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            { displayErrors(errors, 'data.student') }
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.drivers_license'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage><br/>
                            <label onClick={() => { setFieldValue('data.drivers_license', '1') }}>
                                <input disabled={isComplete} id='data.drivers_license' name='data.drivers_license' type="radio" value={values.data.drivers_license} checked={values.data.drivers_license === '1'} onChange={() => { setFieldValue('data.drivers_license', '1') }} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.drivers_license.true'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            <label onClick={() => { setFieldValue('data.drivers_license', '0') }}>
                                <input disabled={isComplete} id='data.drivers_license' name='data.drivers_license' type="radio" value={values.data.drivers_license} checked={values.data.drivers_license === '0'} onChange={() => { setFieldValue('data.drivers_license', '0') }} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.drivers_license.false'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            { displayErrors(errors, 'data.drivers_license') }
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <FormattedMessage id='app.personal_forms_old.attribute.drivers_license_group'>{(txt) => (<label className={values.data.drivers_license === '1' ? 'required-field' : ''}>{txt}</label>)}</FormattedMessage>
                        <input disabled={isComplete} type="text" className='form-control' id='data.drivers_license_group' value={values.data.drivers_license_group} onChange={handleChange}/>
                        { displayErrors(errors, 'data.drivers_license_group') }
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.retiree'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage><br/>
                            <label onClick={() => { setFieldValue('data.retiree', '1'); }}>
                                <input disabled={isComplete} id='data.retiree' name='data.retiree' type="radio" value={values.data.retiree} checked={values.data.retiree === '1'} onChange={() => { setFieldValue('data.retiree', '1') }} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.retiree.true'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            <label onClick={() => { setFieldValue('data.retiree', '0') }}>
                                <input disabled={isComplete} id='data.retiree' name='data.retiree' type="radio" value={values.data.retiree} checked={values.data.retiree === '0'} onChange={() => { setFieldValue('data.retiree', '0') }} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.retiree.false'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            { displayErrors(errors, 'data.retiree') }
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.retirement_type'>{(txt) => (<label className={values.data.retiree === '1' ? 'required-field' : ''}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.retirement_type' value={values.data.retirement_type} onChange={handleChange}/>
                            { displayErrors(errors, 'data.retirement_type') }
                        </div>
                    </div>
                </div>

                <div className='form-group'>
                    <FormattedMessage id='app.personal_forms_old.attribute.health_insurance_company'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                    <input disabled={isComplete} type="text" className='form-control' id='data.health_insurance_company' value={values.data.health_insurance_company} onChange={handleChange}/>
                    { displayErrors(errors, 'data.health_insurance_company') }
                </div>

                <div className='row'>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.disability'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage><br/>
                            <label onClick={() => { setFieldValue('data.disability', '1'); }}>
                                <input disabled={isComplete} id='data.disability' name='data.disability' type="radio" value={values.data.disability} checked={values.data.disability === '1'} onChange={() => { setFieldValue('data.disability', '1') }} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.disability.true'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            <label onClick={() => { setFieldValue('data.disability', '0') }}>
                                <input disabled={isComplete} id='data.disability' name='data.disability' type="radio" value={values.data.disability} checked={values.data.disability === '0'} onChange={() => { setFieldValue('data.disability', '0') }} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.disability.false'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            { displayErrors(errors, 'data.disability') }
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.invalidity'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage><br/>
                            <label onClick={() => { setFieldValue('data.invalidity', '1'); }}>
                                <input disabled={isComplete} id='data.invalidity' name='data.invalidity' type="radio" value={values.data.invalidity} checked={values.data.invalidity === '1'} onChange={() => { setFieldValue('data.invalidity', '1') }} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.invalidity.true'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            <label onClick={() => { setFieldValue('data.invalidity', '0') }}>
                                <input disabled={isComplete} id='data.invalidity' name='data.invalidity' type="radio" value={values.data.invalidity} checked={values.data.invalidity === '0'} onChange={() => { setFieldValue('data.invalidity', '0') }} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.invalidity.false'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            { displayErrors(errors, 'data.invalidity') }
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.invalidity_levels'>{(txt) => (<label className={values.data.invalidity === '1' ? 'required-field' : ''}>{txt}</label>)}</FormattedMessage><br/>
                            <label>
                                <input disabled={isComplete} id='data.invalidity_level_1' name='data.invalidity_level_1' type="checkbox" value={values.data.invalidity_level_1} checked={values.data.invalidity_level_1} onChange={handleChange} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.invalidity_level_1'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            <label>
                                <input disabled={isComplete} id='data.invalidity_level_2' name='data.invalidity_level_2' type="checkbox" value={values.data.invalidity_level_2} checked={values.data.invalidity_level_2} onChange={handleChange} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.invalidity_level_2'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            <label>
                                <input disabled={isComplete} id='data.invalidity_level_3' name='data.invalidity_level_3' type="checkbox" value={values.data.invalidity_level_3} checked={values.data.invalidity_level_3} onChange={handleChange} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.invalidity_level_3'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            { displayErrors(errors, 'data.invalidity_levels') }
                        </div>
                    </div>
                </div>

                <hr/>

                <FormattedMessage id='app.personal_forms_old.attribute.foreigners_info'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.first_cr_employment'>{(txt) => (<label>{txt}</label>)}</FormattedMessage><br/>
                            <label onClick={() => { setFieldValue('data.first_cr_employment', '1'); }}>
                                <input disabled={isComplete} id='data.first_cr_employment' name='data.first_cr_employment' type="radio" value={values.data.first_cr_employment} checked={values.data.first_cr_employment === '1'} onChange={() => { setFieldValue('data.first_cr_employment', '1') }} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.first_cr_employment.true'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            <label onClick={() => { setFieldValue('data.first_cr_employment', '0') }}>
                                <input disabled={isComplete} id='data.first_cr_employment' name='data.first_cr_employment' type="radio" value={values.data.first_cr_employment} checked={values.data.first_cr_employment === '0'} onChange={() => { setFieldValue('data.first_cr_employment', '0') }} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.first_cr_employment.false'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            { displayErrors(errors, 'data.first_cr_employment') }
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <div className='form-group'>
                                <FormattedMessage id='app.personal_forms_old.attribute.foreigner_insurance_number'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                <input disabled={isComplete} type="text" className='form-control' id='data.foreigner_insurance_number' value={values.data.foreigner_insurance_number} onChange={handleChange}/>
                                { displayErrors(errors, 'data.foreigner_insurance_number') }
                            </div>
                        </div>
                    </div>
                </div>

                <hr/>

                <FormattedMessage id='app.personal_forms_old.attribute.education'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>

                <div className='row'>
                    <div className='col-md-8'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.education_school_0'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.education_school_0' value={values.data.education_school_0} onChange={handleChange}/>
                            { displayErrors(errors, 'data.education_school_0') }
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.education_school_0_timespan'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.education_school_0_timespan' value={values.data.education_school_0_timespan} onChange={handleChange}/>
                            { displayErrors(errors, 'data.education_school_0_timespan') }
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-8'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.education_school_1'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.education_school_1' value={values.data.education_school_1} onChange={handleChange}/>
                            { displayErrors(errors, 'data.education_school_1') }
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.education_school_1_timespan'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.education_school_1_timespan' value={values.data.education_school_1_timespan} onChange={handleChange}/>
                            { displayErrors(errors, 'data.education_school_1_timespan') }
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.education_field'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.education_field' value={values.data.education_field} onChange={handleChange}/>
                            { displayErrors(errors, 'data.education_field') }
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.education_exam_type'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.education_exam_type' value={values.data.education_exam_type} onChange={handleChange}/>
                            { displayErrors(errors, 'data.education_exam_type') }
                        </div>
                    </div>
                </div>

                <hr/>

                <div className='row'>
                    <div className='col-12'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.income_deductions'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage><br/>
                            <label onClick={() => { setFieldValue('data.income_deductions', '1'); }}>
                                <input disabled={isComplete} id='data.income_deductions' name='data.income_deductions' type="radio" value={values.data.income_deductions} checked={values.data.income_deductions === '1'} onChange={() => { setFieldValue('data.income_deductions', '1') }} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.income_deductions.true'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            <label onClick={() => { setFieldValue('data.income_deductions', '0') }}>
                                <input disabled={isComplete} id='data.income_deductions' name='data.income_deductions' type="radio" value={values.data.income_deductions} checked={values.data.income_deductions === '0'} onChange={() => { setFieldValue('data.income_deductions', '0') }} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.income_deductions.false'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            </label><br/>
                            { displayErrors(errors, 'data.income_deductions') }
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.residence_permit_no'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.residence_permit_no' value={values.data.residence_permit_no} onChange={handleChange}/>
                            { displayErrors(errors, 'data.residence_permit_no') }
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.residence_permit_expiration_date'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.residence_permit_expiration_date' value={values.data.residence_permit_expiration_date} onChange={handleChange}/>
                            { displayErrors(errors, 'data.residence_permit_expiration_date') }
                        </div>
                    </div>
                </div>

                <hr/>

                <FormattedMessage id='app.personal_forms_old.attribute.foreign_pension'>{(txt) => (<label>{txt}</label>)}</FormattedMessage><br/>
                <FormattedMessage id='app.personal_forms_old.attribute.foreign_pension_additional'>{(txt) => (<small><em>{txt}</em></small>)}</FormattedMessage><br/>

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.foreign_pension_timespan'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.foreign_pension_timespan' value={values.data.foreign_pension_timespan} onChange={handleChange}/>
                            { displayErrors(errors, 'data.foreign_pension_timespan') }
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.foreign_pension_name'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.foreign_pension_name' value={values.data.foreign_pension_name} onChange={handleChange}/>
                            { displayErrors(errors, 'data.foreign_pension_name') }
                        </div>
                    </div>
                </div>

                <br/>

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.foreign_pension_beneficiary_name'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.foreign_pension_beneficiary_name' value={values.data.foreign_pension_beneficiary_name} onChange={handleChange}/>
                            { displayErrors(errors, 'data.foreign_pension_beneficiary_name') }
                        </div>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.foreign_pension_beneficiary_address_street'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.foreign_pension_beneficiary_address_street' value={values.data.foreign_pension_beneficiary_address_street} onChange={handleChange}/>
                            { displayErrors(errors, 'data.foreign_pension_beneficiary_address_street') }
                        </div>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.foreign_pension_beneficiary_address_city'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.foreign_pension_beneficiary_address_city' value={values.data.foreign_pension_beneficiary_address_city} onChange={handleChange}/>
                            { displayErrors(errors, 'data.foreign_pension_beneficiary_address_city') }
                        </div>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.foreign_pension_beneficiary_address_postcode'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.foreign_pension_beneficiary_address_postcode' value={values.data.foreign_pension_beneficiary_address_postcode} onChange={handleChange}/>
                            { displayErrors(errors, 'data.foreign_pension_beneficiary_address_postcode') }
                        </div>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms_old.attribute.foreign_pension_beneficiary_address_country'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.foreign_pension_beneficiary_address_country' value={values.data.foreign_pension_beneficiary_address_country} onChange={handleChange}/>
                            { displayErrors(errors, 'data.foreign_pension_beneficiary_address_country') }
                        </div>
                    </div>
                </div>

                <hr/>

                <div className='form-group'>
                    <label>
                        <input disabled={isComplete} id='data.exclusivity' name='data.exclusivity' type="checkbox" value={values.data.exclusivity} checked={values.data.exclusivity} onChange={handleChange} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.exclusivity'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                        { displayErrors(errors, 'data.exclusivity') }
                    </label>
                </div>

                <div className='form-group'>
                    <label>
                        <input disabled={isComplete} id='data.correctness' name='data.correctness' type="checkbox" value={values.data.correctness} checked={values.data.correctness} onChange={handleChange} onBlur={handleBlur}/> <FormattedMessage id='app.personal_forms_old.attribute.correctness'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                        { displayErrors(errors, 'data.correctness') }
                    </label>
                </div>

                {   !isComplete &&
                <div>
                    <hr/>
                    <button type='button' className='btn btn-primary' disabled={isSubmitting} onBlur={handleBlur} onClick={this.toggle}>{intl.formatMessage({id: 'app.personal_forms.buttons.submit'})}{this.spinner(isSubmitting)}</button>
                </div>
                }

                <PersonalFormSubmitModal isOpen={this.state.submitModal} toggle={this.toggle} submit={submitForm} isSubmitting={isSubmitting}/>
            </form>
        )
    }

}

InnerForm = injectIntl(withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        let model = { ...props.resource };
        return model;
    },
    handleSubmit: (values, form) => { form.props.submit(values, form); },
    displayName: 'BasicForm',
})(InnerForm));


class PersonalForm extends BaseComponent {

    constructor(params) {
        super(params);
        this.state = {
            successModal: false
        }
    }

    sendForm = (values, form) => {
        let promise = this.props.assignmentAction('api/v1', this.props.assignment.id, { execute: 'submit_form', data: values.data });
        handleApiResponse('ASSIGNMENT', 'ACTION', promise,
            (result) => {
                this.setState({...this.state, successModal: true});
            },
            (result) => {
                this.props.setNotification('warning', this.props.intl.formatMessage({id: 'app.personal_forms.message.submit.fail'}));
                let errors = result.payload.response.errors;
                errors = parsePropertiesErrors(errors, 'data');
                form.setErrors(errors);
            },
            (error) => {
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
                console.log(error);
            }).then(() => {
            form.setSubmitting(false);
        });
    };

    render() {
        const initPersonalForm = {
            data: {
                surname: '',
                name: '',
                title: '',
                former_surname: '',
                second_surname: '',
                address_street: '',
                address_city: '',
                address_postcode: '',
                address_country: '',
                contact_address_street: '',
                contact_address_city: '',
                contact_address_postcode: '',
                contact_address_country: '',
                email: '',
                phone: '',
                date_of_birth: '',
                place_of_birth: '',
                citizenship: '',
                personal_identification_number: '',
                student: '',
                retiree: '',
                retirement_type: '',
                drivers_license: '',
                drivers_license_group: '',
                health_insurance_company: '',
                disability: '',
                invalidity: '',
                invalidity_level_1: '',
                invalidity_level_2: '',
                invalidity_level_3: '',
                first_cr_employment: '',
                foreigner_insurance_number: '',
                education_school_0: '',
                education_school_0_timespan: '',
                education_school_1: '',
                education_school_1_timespan: '',
                education_field: '',
                education_exam_type: '',
                income_deductions: '',
                residence_permit_no: '',
                residence_permit_expiration_date: '',
                foreign_pension_timespan: '',
                foreign_pension_name: '',
                foreign_pension_beneficiary_name: '',
                foreign_pension_beneficiary_address_street: '',
                foreign_pension_beneficiary_address_city: '',
                foreign_pension_beneficiary_address_postcode: '',
                foreign_pension_beneficiary_address_country: '',
                correctness: false,
                exclusivity: false
            }
        };

        const { assignment } = this.props;

        const contentUnit = assignment.content_unit;
        const employeeData = assignment.employee_data || initPersonalForm;
        const isComplete = assignment.state === 'complete';

        return (
            <div>
                <ContentUnitHeader contentUnit={contentUnit}/>
                <div className='container'>
                    <InnerForm submit={this.sendForm} resource={employeeData} isComplete={isComplete}/>
                    <AttachmentsList contentUnit={contentUnit}/>
                </div>
                <SuccessModal isOpen={this.state.successModal}>
                    <ModalHeader>{contentUnit.title}</ModalHeader>
                    <ModalBody>
                        <FormattedMessage id='app.personal_forms.message.submit.success'/>
                    </ModalBody>
                    <ModalFooter>
                        <Link to='/dashboard' className={'btn btn-green'}><FormattedMessage id='app.actions.ok'/></Link>
                    </ModalFooter>
                </SuccessModal>
            </div>
        )
    };
}

export default injectIntl(PersonalForm);
